import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AutenticacaoGuard} from "../../core/guards/autenticacao-guard";
import {ProcessoModule} from "./processo/processo.module";
import {DocumentoProcessoModule} from "./documento-processo/documento-processo.module";
import {TarefaModule} from "./tarefa/tarefa.module";
import {AgendaModule} from "./agenda/agenda.module";
import {AudienciaModule} from "./audiencia/audiencia.module";

const routes: Routes = [
  {
    path: 'processo',
    loadChildren: () => ProcessoModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'tarefa',
    loadChildren: () => TarefaModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'documento-processo',
    loadChildren: () => DocumentoProcessoModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'agenda',
    loadChildren: () => AgendaModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'audiencia',
    loadChildren: () => AudienciaModule,
    canActivate: [AutenticacaoGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JuridicoRoutingModule { }
